// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: "https://dev-hillo-api.en-crm-secure.com",
  gamePath: "uploads/games/KOI",
  mediaPath: "uploads/media/HLO",
  koiMediaPath: "uploads/media/KOI",
  siteUrl: "https://dev-hillo-api.en-crm-secure.com",
  // langpath:"./assets/i18n/",
  langpath: "/languages/HLO/",
  paymentIqUrl: "https://test-api.paymentiq.io/paymentiq",
  paymentIqMID: "100348999",
  paymentIqUID: "21",
  notificationZoneID: "10",
  cashierBannerZoneId:'93',
  pnpCashierBannerZoneId:'94',
  semiPnpZimplerCountries:[],
  blockedUserSegments:[],
  fullPnpCountries:['FI','EE'],
  liveGameUrl: "prelive-dga.pragmaticplaylive.net",
  liveGameCasioID: "ppcdk00000005449",
  sandboxState: true,
  website_name: "hillo",
  zimplerPnp:[],
  website_code: "HLO",
  website_logo_extension: "svg",
  hasLandingpage: false,
  landingpageCountries: [],
  pnpCountryList:["EE","FI"],
  trustlyCountries: [],
  restrictNoIndexLanguages: {
    'pl':'pl'
  },
  zimplerCountries:['EE','FI'],
  zimplerDefaultLanguage: 'en',
  specifiedMappedLanguages:{
    'in':'ei',
    'en':'en',
    'pl':'pl',
    'no':'no',
    'fi':'fi',
    'et':'et',
    'cd':'cd',
    'nz':'nz',
    'hu':'hu'
  },
  xSaleBuumiCountries:[],
  zimplerCountriesAvailableLanguages: {},
  site: 'koicasino',
  siteDisplayName: 'Koicasino.com',
  trustlyUrl: "https://test.trustly.com",
  stepThreeDepositIsEnabled:false,
  currencyForMoonpay:["BITCOIN"],
  gameWindowAdjustableVendorList:['hub88_plb'],
  hreflangAttributeCodes: {
    'en': 'en',
    'cd': 'en-ca',
    'nz': 'en-nz',
    'no': 'no',
    'pl': 'pl',
    'fi': 'fi',
    'in': 'in',
    'et': 'et',
    'hu': 'hu'
  },
  countryLanguage: {
    'SE': 'en',
    'AX': 'sv',
    'NO': 'no',
    'FI': 'fi',
    'NZ': 'nz',
    'CA': 'cd',
    'IN': 'in',
    'EE': 'et',
    'HU': 'hu'
  },
  demoGamesExemptedCountries:[],
  GAME_PROVIDERS_VENDOR_CODE_SORT_ORDER: [
    "pragmaticplay",
    "netent",
    "redtiger",
    "relax",
    "big_time_gaming",
    "evolution_gaming",
    "blueprint",
    "vanguard",
    "pushgaming",
    "quickspin",
    "isoftbet",
    "nyx",
    "sg_digital",
    "nolimit_city",
    "onextwo",
    "betsoft",
    "booming",
    "greentube",
    "thunderkick",
    "elk",
    "iron_dog_studio",
    "just_for_the_win",
    "kalamba",
    "oryx_gaming",
    "playson",
    "gamomat",
    "fortune_factory",
    "foxium",
    "gameburger",
    "golden_hero",
    "golden_rock_studios",
    "lightning_box",
    "northern_lights",
    "pocket_games_soft",
    "rabcat",
    "reelplay",
    "slingshot",
    "sthlm_gaming",
    "stormcraft_studios",
    "triple_edge"],
    stepThreeRegistrationExemption: true,
    stepThreeRegistrationReqCountriesWhenExempted: [
      "AF",
      "AX",
      "AL",
      "DZ",
      "AS",
      "AD",
      "AO",
      "AI",
      "AQ",
      "AG",
      "AR",
      "AM",
      "AW",
      "AU",
      "AT",
      "AZ",
      "BS",
      "BH",
      "BD",
      "BB",
      "BY",
      "BE",
      "BZ",
      "BJ",
      "BM",
      "BT",
      "BO",
      "BQ",
      "BA",
      "BW",
      "BV",
      "BR",
      "IO",
      "BN",
      "BG",
      "BF",
      "BI",
      "KH",
      "CM",
      "CV",
      "KY",
      "CF",
      "TD",
      "CL",
      "CN",
      "CX",
      "CC",
      "CO",
      "KM",
      "CG",
      "CK",
      "CR",
      "CI",
      "HR",
      "CU",
      "CW",
      "CY",
      "CZ",
      "CD",
      "DK",
      "DJ",
      "DM",
      "DO",
      "EC",
      "EG",
      "SV",
      "GQ",
      "ER",
      "EE",
      "ET",
      "FK",
      "FO",
      "FJ",
      "FI",
      "FR",
      "GF",
      "PF",
      "TF",
      "GA",
      "GM",
      "GE",
      "DE",
      "GH",
      "GI",
      "GR",
      "GL",
      "GD",
      "GP",
      "GU",
      "GT",
      "GG",
      "GN",
      "GW",
      "GY",
      "HT",
      "HM",
      "VA",
      "HN",
      "HK",
      "HU",
      "IS",
      "IN",
      "ID",
      "IR",
      "IQ",
      "IE",
      "IM",
      "IL",
      "IT",
      "JM",
      "JE",
      "JO",
      "KZ",
      "KE",
      "KI",
      "KP",
      "KR",
      "KW",
      "KG",
      "LA",
      "LV",
      "LB",
      "LS",
      "LR",
      "LY",
      "LI",
      "LT",
      "LU",
      "MO",
      "MK",
      "MG",
      "MW",
      "MY",
      "MV",
      "ML",
      "MT",
      "MH",
      "MQ",
      "MR",
      "MU",
      "YT",
      "MX",
      "FM",
      "MD",
      "MC",
      "MN",
      "ME",
      "MS",
      "MA",
      "MZ",
      "MM",
      "NA",
      "NR",
      "NP",
      "NL",
      "AN",
      "NC",
      "NI",
      "NE",
      "NG",
      "NU",
      "NF",
      "MP",
      "NO",
      "OM",
      "PK",
      "PW",
      "PS",
      "PA",
      "PG",
      "PY",
      "PE",
      "PH",
      "PN",
      "PL",
      "PT",
      "PR",
      "QA",
      "RE",
      "RO",
      "RU",
      "RW",
      "SH",
      "KN",
      "LC",
      "MF",
      "PM",
      "BL",
      "WS",
      "SM",
      "ST",
      "SA",
      "SN",
      "RS",
      "CS",
      "SC",
      "SL",
      "SG",
      "SX",
      "SK",
      "SI",
      "SB",
      "SO",
      "ZA",
      "GS",
      "SS",
      "ES",
      "LK",
      "VC",
      "SD",
      "SR",
      "SJ",
      "SZ",
      "SE",
      "CH",
      "SY",
      "TW",
      "TJ",
      "TZ",
      "TH",
      "TL",
      "TG",
      "TK",
      "TO",
      "TT",
      "TN",
      "TR",
      "TM",
      "TC",
      "TV",
      "UG",
      "UA",
      "AE",
      "GB",
      "US",
      "UM",
      "UY",
      "UZ",
      "VU",
      "VE",
      "VN",
      "VG",
      "VI",
      "WF",
      "EH",
      "YE",
      "ZM",
      "ZW"
    ],
    totalStepThreeRegistrationExemption: {},
    zendeskServiceConfig : {
      isEnabled: true,
      scriptPath : "https://static.zdassets.com/ekr/snippet.js?key=cd336111-f9e9-45f2-9431-2f43287f0324",
      chatEnabledLanguages: {
        en: "Hillo English Support",
        fi: "Hillo Asiakaspalvelu Suomeksi",
        pl: "Hillo Polskie Wsparcie",
        no: "Hillo Norsk Kundeservice"
      },
      chatTags: ["hillo"],
      chatTagsForVip: ["hillo", "VIP"]
    },
    chatService:"freshChat",
    freshChatConfig: {
      scriptPath: "https://eu.fw-cdn.com/12512065/556764.js",
      host:"",
      token:"",
      widgetId:"6cdc9beb-f853-4714-b0de-5de3cc8d5d22"
    },
    tugiChatConfig: {
          tugiChatEnabled:false,
          tenantId : "kyzenservices",
          brandId:"853375d4a75d471b8d24fb8830f62e19",
          scriptPath:"https://app.tugi.ai/tugi.widget/script",
          brandName:"Slotti",
          useProviderJwt:true,
          theme:{
            primaryColor: "#1E3DE4",
            secondaryColor: "#071352",
            homePageBackgroundColor: "#1E3DE4",
            homePageTextColor: "#FFFFFF",
          }
      },
    coolOff:{
      enabled:true,
    }
  };
